import { put, select, takeLatest } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import { Types, Creators as SiteMapCreators } from '../../reducers/sitemap';
import getState from '../../utils/getState';

function* findText({ text }) {
  try {
    const { sitemap } = yield select(getState);
    const filteredCategories = sitemap
      .getIn(['fullCategories'])
      .filter((item) => (item.name || '').toLowerCase().includes(text.toLowerCase()));

    yield put(SiteMapCreators.getCategoriesSuccess({ categories: filteredCategories }));
    yield put(SiteMapCreators.findTextSuccess());
  } catch (error) {
    yield put(SiteMapCreators.findTextError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.FIND_TEXT_REQUEST, findText);
}
